import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssueFormCompanyCategoriesController',
            IssueFormCompanyCategoriesController
        );

    function IssueFormCompanyCategoriesController(CategoriesFactory) {
        var vm = this;

        init();

        function init() {
            vm.dataFromBackend = [];
            getCategories(vm.companyId);
        }

        function getCategories(companyId) {
            CategoriesFactory.get(companyId).then(function (response) {
                vm.categories = response.data;
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/company-categories/issue_form_category.controller.ts